var React = require('react');

function Trash (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.97656 3.05469H5.84375C5.9168 3.05469 5.97656 2.99492 5.97656 2.92188V3.05469H11.0234V2.92188C11.0234 2.99492 11.0832 3.05469 11.1562 3.05469H11.0234V4.25H12.2188V2.92188C12.2188 2.33584 11.7423 1.85938 11.1562 1.85938H5.84375C5.25771 1.85938 4.78125 2.33584 4.78125 2.92188V4.25H5.97656V3.05469ZM14.3438 4.25H2.65625C2.3624 4.25 2.125 4.4874 2.125 4.78125V5.3125C2.125 5.38555 2.18477 5.44531 2.25781 5.44531H3.26055L3.67061 14.1279C3.69717 14.694 4.16533 15.1406 4.73145 15.1406H12.2686C12.8363 15.1406 13.3028 14.6957 13.3294 14.1279L13.7395 5.44531H14.7422C14.8152 5.44531 14.875 5.38555 14.875 5.3125V4.78125C14.875 4.4874 14.6376 4.25 14.3438 4.25ZM12.1407 13.9453H4.85928L4.45752 5.44531H12.5425L12.1407 13.9453Z","fill":"#8A9DA4"}));
}

Trash.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = Trash;

Trash.default = Trash;
